import Institution from "./Institution"
import ResourceModel from "models/convention-api/ResourceModel"
import moment from "moment-timezone"

export default class ConventionProviderExhibitor extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/convention_provider_exhibitors"

  protected static rels = {
    institution: () => ({
      type: Institution,
      from: "institution_id",
      filterOn: "id",
    }),
  }

  announcement!: string
  call_to_action_name!: string
  call_to_action_url!: string
  disabled!: boolean
  chat_available!: boolean
  institution_id!: string
  featured!: boolean
  created_at!: moment.Moment
  cover_photo_thumb_url!: string
  cover_photo_url!: string
  bio!: string

  institution?: Institution
}
